import React from 'react';
import { withInject } from '@piwikpro/platform';
import { connect, ConnectedProps } from 'react-redux';
import { OrganizationState } from '@piwikpro/organization-crate';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { MarketingCratePaymentsState } from '@piwikpro/marketing-crate/redux';
import {
  LicenseDetailsHeader,
} from '@piwikpro/organization-crate/components/LicenseDetailsHeader/LicenseDetailsHeader';

const mapStateToProps = (state: MarketingCratePaymentsState & { organization: OrganizationState, session: SessionState }) => ({
  subscription: state.payments.subscription,
  license: state.organization.details,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  LicenseDetailsHeaderComponent: typeof LicenseDetailsHeader
}

interface Props extends ReduxProps, InjectedProps { }

export const LicenseDetailsPlan: React.FC<Props> = ({
  license,
  subscription,
  LicenseDetailsHeaderComponent,
}) => (
  <LicenseDetailsHeaderComponent
    mode="administration"
    loading={license.isLoading || subscription.isLoading}
    error={license.failed}
    license={license.license.current}
    upcomingLicense={license.license.upcoming}
    subscription={subscription.details}
  />
);

export default connector(withInject<InjectedProps>({
  LicenseDetailsHeaderComponent: 'OrganizationCrate.components.LicenseDetailsHeader',
})(LicenseDetailsPlan as any));
